// extracted by mini-css-extract-plugin
export default {"file-input":"FileInput_file-input__A-iMZ","file":"FileInput_file__Gh-4l","delete-file":"FileInput_delete-file__pswRF","button-container":"FileInput_button-container__nXS2E"};